import {
  GET_SELLER_STATS_ATTEMPT,
  GET_SELLER_STATS_SUCCESS,
  GET_SELLER_STATS_FAILURE,
} from "../../constants";

import { SellerStatsInitialState } from "../../../types/orders/sellerStats";

const initialState: SellerStatsInitialState = {
  fetchingSellerStats: 0,
  errorMessage: "",
  success: true,
  sellerStats: [],
  total: 0,
  skip: 0,
  take: 20,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    // getSellerStats
    case GET_SELLER_STATS_ATTEMPT:
      return {
        ...state,
        fetchingSellerStats: state.fetchingSellerStats + 1,
        success: true,
        errorMessage: "",
        skip: action.payload.skip || 0,
        take: action.payload.take || 20,
      };
    case GET_SELLER_STATS_SUCCESS:
      return {
        ...state,
        fetchingSellerStats: state.fetchingSellerStats - 1,
        success: true,
        errorMessage: "",
        sellerStats: action.payload.data,
        total: action.payload.total,
      };
    case GET_SELLER_STATS_FAILURE:
      return {
        ...state,
        fetchingSellerStats: state.fetchingSellerStats - 1,
        success: false,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
};
